import tutorialApi from '../../../api/tutorial';
import optionApi from '../../../api/option';

const defaultState = () => ({
    tutorialResults: [],
    tutorialPagination: '',
    tutorialCategory: [],
    responSukses: '',
    konfirmResponse: {},
    alertMultiple: [],
    imageName: '',
    alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {

    listTutorial(state, data) {
        state.tutorialResults = data.data.map((el) => {
            if (el.tutorial_status == "1") {
                el.tutorial_status = true
            } else {
                el.tutorial_status = false
            }
            return el
        });
        state.tutorialPagination = data.pagination;
    },
    listOptionTutorialCategory(state, data) {
		state.tutorialCategory = data;
	},
    konfirmasiSukses(state, data) {
        state.konfirmResponse = {};
        state.responSukses = data;
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = data;
    },
    setImageName(state, { data : { results : { tutorial_thumbnail } } } ) {
		state.imageName = tutorial_thumbnail
	},
    multipleAlert(state, data) {
        state.alertMultiple = data.map((el) => {
            return {
                show: true,
                message: el
            }
        })
    },
    failed(state, data) {
        state.alert = data
    },
    clearDataTutorial(state) {
        Object.assign(state, defaultState());
    },
};

const actions = {
    getTutorial({ commit }, param) {
        tutorialApi.getDataTutorial(param).then(({ data: { data } }) => {
            commit('listTutorial', { data: data.results, pagination: data.pagination });
        }).catch(() => {
            commit('listTutorial', { data: [], pagination: {} });
        });
    },
    async addTutorial({ dispatch, commit }, value) {
        commit("konfirmasiSukses", '');
        await tutorialApi.addTutorial(value).then( res => {
            const data = res.data;
            dispatch('success', data)
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data)
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal menambah Tutorial'
            }, { root: true });
        });
    },
    async updateTutorial({ dispatch, commit }, value) {
        commit("konfirmasiSukses", '');
        await tutorialApi.updateTutorial(value).then( res => {
            const data = res.data;
            dispatch('success', data)
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data)
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal mengubah Tutorial'
            }, { root: true });
        });
    },
    async deleteTutorial({ dispatch, commit }, value) {
        commit("konfirmasiSukses", '');
        await tutorialApi.deleteTutorial({ id: value }).then( res => {
            const data = res.data;
            dispatch('success', data)
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data)
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal menghapus Tutorial'
            }, { root: true });
        });
    },
    async statusTutorial({ dispatch, commit }, value) {
        commit("konfirmasiSukses", '');
        await tutorialApi.statusTutorial(value).then( res => {
            const data = res.data;
            dispatch('success', data)
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data)
            commit('setSnackbar', {
                show: true,
                color: 'red darken-2',
                text: 'Gagal mengubah status Tutorial'
            }, { root: true });
        });
    },
    getTutorialCategoryOption({ commit }) {
        return new Promise((resolve) => {
            optionApi.getOptionsTutorialCategory().then(({ data: { data: { results } } }) => {
                commit('listOptionTutorialCategory', results);
                resolve(results)
            }).catch(() => {
                commit('listOptionTutorialCategory', []);
                resolve([])
            });
        })
    },
    async uploadImage({ commit , dispatch}, value) {
        await dispatch('isAttempting', null, { root: true })
        await tutorialApi.uploadImage(value).then( ({ data }) => {
            commit("setImageName", data)
        })
        .catch(err => {
            const data = err.response.data
            dispatch("errorHandler", data);
        });
        await dispatch('attempted', null, { root: true })
    },
    success({ commit }, data) {
        commit('setSnackbar', {
            show: true,
            color: 'green accent-4',
            text: data.message
        }, { root: true });
    },
    errorHandler({ commit }, response) {
        switch (response.message) {
            case 'error_validation':
            commit('saveConfirmResponse', response.data);
            break;

            case 'error_multiple_alert':
            commit('multipleAlert', response.data.error)
            break;

            default:
            commit('failed', { code: 'error_response', type: 'error', message: response.message });
            break;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};